import { APP_SOURCE } from "@/config";

export const sendMessageToParent = (
  type: string,
  payload: any = {},
  targetOrigin: string | null = null
) => {
  const origin = targetOrigin || "*";

  window.parent.postMessage(
    {
      source: APP_SOURCE,
      type,
      payload,
    },
    origin
  );
};
